/* TCC quizzes: one engine, quiz content in assets/tcc-quiz-<id>.json. See sections/tcc-quiz.liquid. */
(function () {
  var QUIZZES = [
    { id: 'pokemon', url: '/pages/quiz-pokemon', t: 'Which Pokémon are you?' },
    { id: 'set', url: '/pages/quiz-set', t: 'Which set should you open next?' },
    { id: 'language', url: '/pages/quiz-language', t: 'Which language should you collect?' },
    { id: 'gym-leader', url: '/pages/quiz-gym-leader', t: 'Which gym leader are you?' },
    { id: 'generation', url: '/pages/quiz-generation', t: 'Which generation are you?' },
    { id: 'spin-off', url: '/pages/quiz-spin-off', t: 'Which spin-off are you?' },
    { id: 'legendary', url: '/pages/quiz-legendary', t: 'Which legendary are you?' },
    { id: 'professor', url: '/pages/quiz-professor', t: 'Which professor are you?' },
    { id: 'rival', url: '/pages/quiz-rival', t: 'Which rival are you?' },
    { id: 'starter', url: '/pages/quiz-starter', t: 'Which starter are you?' },
    { id: 'type', url: '/pages/quiz-type', t: 'Which type are you?' }
  ];
  var LANG_RANK = { K: 0, C: 0, J: 1 }; // KR + CN first, JP after

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(root, cls) { var el = root.querySelector(cls); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* core:start (build/sim-mc.js and build/tune.js run this exact code, so the balance check matches the live quiz) */
  // A run = Q.show questions from the pool, each showing at most Q.answers (default 4) of its answers (Alex 13 Oct 2026).
  // Every result must sit on at least Q.cover (default 2) of the answers on screen, so no result is rotated out of a run
  // (e.g. a professor whose answers all got hidden). Random draw + answer swaps to fill gaps, retried until it holds.
  function tccDraw(Q, rnd) {
    var N = Q.questions.length, n = Math.min(Q.show || N, N), A = Q.answers || 4, T = Q.cover || 2, keys = Object.keys(Q.results);
    var num = function (a, b) { return a - b; };
    var shuf = function (a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; };
    var has = function (qn, ai, k) { return (Q.questions[qn].a[ai].s[k] || 0) > 0; };
    var best = null, bestSc = -1e9;
    for (var tries = 0; tries < 200; tries++) {
      var qs = shuf(Q.questions.map(function (_, i) { return i; })).slice(0, n).sort(num);
      var opts = qs.map(function (qn) { return shuf(Q.questions[qn].a.map(function (_, i) { return i; })).slice(0, A).sort(num); });
      var cnt = {}; keys.forEach(function (k) { cnt[k] = 0; });
      opts.forEach(function (o, p) { o.forEach(function (ai) { for (var k in Q.questions[qs[p]].a[ai].s) if (Q.questions[qs[p]].a[ai].s[k] > 0) cnt[k]++; }); });
      for (var pass = 0; pass < 60; pass++) {
        var low = keys.filter(function (k) { return cnt[k] < T; }); if (!low.length) break;
        var k = low[Math.floor(rnd() * low.length)], swapped = false, order = shuf(qs.map(function (_, p) { return p; }));
        for (var oi = 0; oi < order.length && !swapped; oi++) {
          var p = order[oi], qn = qs[p], all = Q.questions[qn].a;
          for (var h = 0; h < all.length && !swapped; h++) {
            if (opts[p].indexOf(h) > -1 || !has(qn, h, k)) continue;
            for (var x = 0; x < opts[p].length && !swapped; x++) {
              var ax = opts[p][x], ok = !has(qn, ax, k);
              for (var r in all[ax].s) if (all[ax].s[r] > 0 && cnt[r] <= T && !has(qn, h, r)) ok = false;
              if (!ok) continue;
              for (var r1 in all[ax].s) if (all[ax].s[r1] > 0) cnt[r1]--;
              for (var r2 in all[h].s) if (all[h].s[r2] > 0) cnt[r2]++;
              opts[p][x] = h; opts[p].sort(num); swapped = true;
            }
          }
        }
        if (!swapped) break;
      }
      var m = Infinity, under = 0; keys.forEach(function (k) { m = Math.min(m, cnt[k]); if (cnt[k] < T) under++; });
      var sc = Math.min(m, T) * 1000 - under;
      if (sc > bestSc) { bestSc = sc; best = { qs: qs, opts: opts }; }
      if (m >= T) break;
    }
    return best;
  }
  // Score = points / the most that result could have scored on the answers shown, so a result whose best answers
  // weren't drawn can still win. Q.bias (e.g. language quiz jp/en 0.85) shades a result down unless the answers clearly point to it.
  function tccScore(Q, qs, opts, picks) {
    var s = {}, max = {}, keys = Object.keys(Q.results), bias = Q.bias || {};
    qs.forEach(function (qn, i) {
      var q = Q.questions[qn], w = q.a[picks[i]].s;
      for (var k in w) s[k] = (s[k] || 0) + w[k];
      keys.forEach(function (k) { max[k] = (max[k] || 0) + Math.max.apply(null, opts[i].map(function (ai) { return q.a[ai].s[k] || 0; })); });
    });
    var best = -1, tied = [];
    keys.forEach(function (k) { if (!max[k]) return; var v = Math.round(1e6 * (s[k] || 0) / max[k] * (bias[k] || 1)); if (v > best) { best = v; tied = [k]; } else if (v === best) tied.push(k); });
    return tied;
  }
  /* core:end */

  function hash(str) { var h = 0; for (var i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0; return Math.abs(h); }

  function init(root) {
    var stage = root.querySelector('.tcc-quiz__stage');
    var id = root.getAttribute('data-quiz');
    var feed = readJSON(root, '.tcc-quiz__feed') || [];
    var langFeed = readJSON(root, '.tcc-quiz__lang') || {};
    var imgs = readJSON(root, '.tcc-quiz__img') || {};
    var Q, idx = 0, picks = [], qs = [], opts = [], ref = null, finished = true, shown = null;
    var landing = new URLSearchParams(location.search); // read once: the URL is rewritten to ?r= on the result

    var N = { ppb: {}, facts: {} };
    Promise.all([root.getAttribute('data-src'), root.getAttribute('data-notes')].map(function (u) { return fetch(u).then(function (r) { return r.json(); }); })).then(function (all) {
      Q = all[0]; N = all[1];
      var r = new URLSearchParams(location.search).get('r');
      if (r && Q.results[r]) renderResult(r, true); else renderIntro();
    }).catch(function () { stage.innerHTML = '<p>Sorry, the quiz didn’t load. Try refreshing.</p>'; });

    function scrollTop() { var y = root.getBoundingClientRect().top + window.pageYOffset - 90; if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' }); }

    function renderIntro() {
      stage.innerHTML =
        '<h1 class="tcc-quiz__h1">' + esc(Q.title) + '</h1>' +
        '<p class="tcc-quiz__lede">' + esc(Q.intro) + '</p>' +
        '<button class="tcc-quiz__btn" data-act="start">Start the quiz</button>';
      track('view');
    }

    // Each run shows Q.show questions drawn at random from the pool (kept in pool order), 4 answers each, so retakes feel different.
    function draw() {
      var run = tccDraw(Q, Math.random); qs = run.qs; opts = run.opts; idx = 0; picks = [];
      // a new run: its random ref ties that run's start/complete/abandon rows together (anonymous)
      ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); finished = false;
      track('start');
    }

    function renderQ() {
      var q = Q.questions[qs[idx]], n = qs.length;
      // quiz title stays on screen as a small header (Alex 12 Oct: on phones the bar alone looked like something was missing)
      var html = '<p class="tcc-quiz__kicker">' + esc(Q.title) + '</p>' +
        '<div class="tcc-quiz__top"><button class="tcc-quiz__back" data-act="back"' + (idx ? '' : ' disabled') + '>← Back</button>' +
        '<span class="tcc-quiz__count">Question ' + (idx + 1) + ' of ' + n + '</span></div>' +
        '<div class="tcc-quiz__bar"><span style="width:' + Math.round(100 * idx / n) + '%"></span></div>' +
        '<h2 class="tcc-quiz__q">' + esc(q.q) + '</h2><div class="tcc-quiz__opts' + (opts[idx].every(function (i) { return q.a[i].img; }) ? ' tcc-quiz__opts--img' : '') + '">';
      opts[idx].forEach(function (i) { var a = q.a[i];
        html += '<button class="tcc-quiz__opt' + (picks[idx] === i ? ' is-picked' : '') + '" data-act="pick" data-i="' + i + '">' + (a.img ? '<img src="' + esc(root.getAttribute('data-assets') + a.img) + '" alt="" loading="eager" width="600" height="400">' : '') + '<span>' + esc(a.t) + '</span></button>';
      });
      stage.innerHTML = html + '</div>';
      scrollTop();
    }

    function score() {
      var tied = tccScore(Q, qs, opts, picks);
      return tied[hash(qs.join(',') + ':' + picks.join('')) % tied.length];
    }

    function productCard(p) {
      var handle = (String(p.u).match(/\/products\/([^/?#]+)/) || [])[1] || p.u;
      return '<a class="tcc-quiz__p" href="' + esc(p.u) + '" data-click="product:' + esc(handle) + (p.a ? '' : ':soldout') + '">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="300" height="300">' : '') +
        '<span class="tcc-quiz__pb"><span class="tcc-quiz__pt">' + esc(p.t) + '</span>' +
        (p.a ? '<span class="tcc-quiz__pp">' + esc(p.p) + '</span><span class="tcc-quiz__pc">Shop now</span>'
             : '<span class="tcc-quiz__pn">Sold out</span><span class="tcc-quiz__pc">Get notified</span>') + '</span></a>';
    }

    function productsFor(key, res) {
      if (id === 'pokemon' || res.families) {
        var fams = res.families || [res.family], seen = {}, out = [];
        feed.filter(function (p) { return p.a && p.f && p.f.some(function (f) { return fams.indexOf(f) > -1; }); })
          .sort(function (a, b) {
            var la = LANG_RANK[a.s.charAt(0)], lb = LANG_RANK[b.s.charAt(0)];
            if (la !== lb) return (la == null ? 9 : la) - (lb == null ? 9 : lb);
            // fewer Pokémon in the set = this one is a bigger share of the pulls
            if (a.f.length !== b.f.length) return a.f.length - b.f.length;
            return (/BOX$/.test(b.s) ? 1 : 0) - (/BOX$/.test(a.s) ? 1 : 0);
          })
          .forEach(function (p) { var set = p.s.split('-')[2]; if (out.length < 4 && !seen[set]) { seen[set] = 1; out.push(p); } });
        return out;
      }
      if (id === 'set') {
        return res.skus.map(function (s) { return feed.filter(function (p) { return p.s === s; })[0]; }).filter(Boolean);
      }
      return langFeed[key] || [];
    }

    // ---- Alex's note: assembled from what is in stock right now, so it never names something we can't sell.
    function setKey(sku) { return String(sku || '').replace(/^[KJC]-PKMN-/, '').replace(/-(BOX|PACK)$/, ''); }
    function nameOf(p) { return (N.names && N.names[setKey(p.s)]) || setName(p.t); }
    function setName(t) { return String(t).replace(/\s*\((KOR|JPN|CHN)\)/, '').replace(/ (Booster Box|Booster Pack|Blind Box)$/, '').trim(); }
    function money(p) { return parseFloat(String(p).replace(/[^0-9.]/g, '')) || 0; }
    function packOf(box) { var s = box.s.replace(/-BOX$/, '-PACK'); return feed.filter(function (p) { return p.s === s && p.a; })[0]; }
    function aboutBox(box) {
      var k = setKey(box.s), out = [];
      if (N.facts[k]) out.push(N.facts[k]);
      var ppb = N.ppb[k];
      if (/-BOX$/.test(box.s) && ppb) out.push('That\'s ' + ppb + ' packs for ' + box.p + ', about £' + (money(box.p) / ppb).toFixed(2) + ' a pack.');
      var pack = /-BOX$/.test(box.s) ? packOf(box) : null;
      if (money(box.p) >= 100 && pack) out.push('If a full box is too much, the packs are ' + pack.p + ' each.');
      return out.join(' ');
    }
    function buildNote(key, res, prods) {
      if (id === 'pokemon') {
        var sets = {};
        feed.forEach(function (p) { if (p.a && p.f && p.f.indexOf(res.family) > -1) sets[setKey(p.s)] = 1; });
        var n = Object.keys(sets).length;
        if (!n || !prods.length) return 'Nothing with ' + res.name + ' in it is in stock right now, but it won\'t be long.';
        var lead = prods[0];
        return (n === 1 ? res.name + ' is only in one set we\'ve got in stock: ' + nameOf(lead) + '. '
                        : res.name + ' is in ' + n + ' of the sets we\'ve got in stock. I\'d start with ' + nameOf(lead) + '. ') +
          aboutBox(lead);
      }
      if (id === 'set') {
        var box = prods.filter(function (p) { return !/-PACK$/.test(p.s); })[0], pack = prods.filter(function (p) { return /-PACK$/.test(p.s); })[0];
        if (box && box.a) return aboutBox(box);
        var fact = N.facts[setKey((box || pack || {}).s)] || '';
        if (pack && pack.a) return 'The boxes have gone for now, but the packs are still here at ' + pack.p + ' each. ' + fact;
        return 'It\'s sold out right now. Press Get notified and we\'ll email you when it\'s back.';
      }
      var top = prods[0];
      return (res.note || '') + (top ? ' If you\'re starting out, I\'d go for ' + nameOf(top) + '. ' + aboutBox(top) : '');
    }

    function renderResult(key, fromLink) {
      shown = key;
      var res = Q.results[key];
      var prods = productsFor(key, res);
      var html = '<div class="tcc-quiz__res" style="--c:' + esc(res.color) + '">';
      if (id === 'set' && prods[0] && prods[0].i) html += '<img class="tcc-quiz__portrait tcc-quiz__boxart" src="' + esc(prods[0].i) + '" alt="' + esc(res.name) + '" width="160" height="160">';
      // Every other result shows card art (Alex 28 Oct 2026: "Each end card should have a connected illustration").
      else if (res.img) html += '<img class="tcc-quiz__art" src="' + esc(root.getAttribute('data-assets') + res.img) + '" alt="' + esc(res.name) + '" width="600" height="400">';
      else if (id === 'pokemon' && imgs[key]) html += '<img class="tcc-quiz__portrait tcc-quiz__px" src="' + esc(imgs[key]) + '" alt="' + esc(res.name) + '" width="160" height="160">';
      else html += '<div class="tcc-quiz__badge">' + esc(id === 'language' ? key.toUpperCase() : res.name.charAt(0)) + '</div>';
      html += '<p class="tcc-quiz__you">' + (fromLink ? 'Their result' : (id === 'set' ? 'Your next set' : (id === 'language' ? 'You collect' : 'You are'))) + '</p>' +
        '<h1 class="tcc-quiz__name">' + esc(res.name) + '</h1>' +
        (res.lang ? '<p class="tcc-quiz__you">' + esc(res.lang) + '</p>' : '') +
        '<p class="tcc-quiz__tag">' + esc(res.tag) + '</p>' +
        '<p class="tcc-quiz__blurb">' + esc(res.blurb) + '</p></div>';

      if (prods.length) {
        var head = Q.shop ? Q.shop.replace('{name}', res.name) : (id === 'pokemon' ? 'Sets with ' + res.name + ' in' : (id === 'set' ? 'Shop this set' : res.name + ' boxes to start with'));
        html += '<h2 class="tcc-quiz__h2">' + esc(head) + '</h2><div class="tcc-quiz__grid">' + prods.map(productCard).join('') + '</div>';
      }
      var more = '';
      if (id === 'pokemon' && res.collection) more = '<a href="/collections/' + esc(res.collection) + '" data-click="all">Shop everything ' + esc(res.name) + ' →</a>';
      if (id === 'language' && res.landing) more = '<a href="' + esc(res.landing) + '" data-click="all">See all ' + esc(res.name) + ' Pokémon →</a>';
      if (more) html += '<p class="tcc-quiz__more">' + more + '</p>';
      if (id === 'pokemon') html += '<p class="tcc-quiz__member">Members pick a favourite Pokémon and save up to 7% on every product it’s in. <a href="/pages/membership" data-click="membership">See membership →</a></p>';

      html += '<div class="tcc-quiz__btns">' +
        (fromLink ? '<button class="tcc-quiz__btn" data-act="restart">Take the quiz</button>'
                  : '<button class="tcc-quiz__btn" data-act="share" data-k="' + esc(key) + '">Share my result</button><button class="tcc-quiz__btn tcc-quiz__btn--ghost" data-act="restart">Have another go</button>') +
        '<span class="tcc-quiz__toast" hidden></span></div>';
      html += '<h2 class="tcc-quiz__h2">More quizzes</h2><div class="tcc-quiz__others">' +
        QUIZZES.filter(function (q) { return q.id !== id; }).sort(function () { return Math.random() - .5; }).slice(0, 4).map(function (q) { return '<a class="tcc-quiz__btn tcc-quiz__btn--ghost" href="' + q.url + '" data-click="quiz:' + q.id + '">' + esc(q.t) + '</a>'; }).join('') + '</div>';
      stage.innerHTML = html;
      scrollTop();
      if (!fromLink) {
        try { history.replaceState(null, '', location.pathname + '?r=' + encodeURIComponent(key)); } catch (e) {}
        finished = true;
        track('complete', key);
      }
    }

    // Measurement: anonymous cohort rows to the WMS only (server/quizLog.js via the App Proxy). Nothing goes on the
    // cart or to Shopify customer events, so a quiz can never be tied to an account or order (Alex, 11 Oct 2026).
    function track(step, result) {
      if (step === 'view' || step === 'start' || step === 'complete') log(step, result);
    }

    function log(event, result, beacon, clicked) {
      try {
        var p = landing;
        var answers = event === 'view' || event === 'click' ? [] : picks.map(function (ai, i) {
          var q = Q.questions[qs[i]]; return { q: qs[i], question: q.q, a: ai, answer: q.a[ai].t };
        });
        var body = JSON.stringify({
          event: event, ref: ref, quiz: id, result: result || null, answers: answers, n_questions: qs.length || null, clicked: clicked || null,
          mobile: window.matchMedia('(max-width: 749px)').matches, referrer: document.referrer ? new URL(document.referrer).hostname : null,
          src: p.get('src'), utm_source: p.get('utm_source'), utm_medium: p.get('utm_medium'), utm_campaign: p.get('utm_campaign'),
          theme: window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' ? 'dev' : 'live'
        });
        var url = '/apps/membership/quiz/log';
        if (beacon && navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
        else fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    // left part-way through: record how far they got
    window.addEventListener('pagehide', function () { if (ref && !finished) { finished = true; log('abandon', null, true); } });

    function share(key) {
      var res = Q.results[key];
      var url = location.origin + location.pathname + '?r=' + encodeURIComponent(key);
      var text = Q.share.replace('{name}', res.name);
      var toast = stage.querySelector('.tcc-quiz__toast');
      function done(msg) { if (toast) { toast.textContent = msg; toast.hidden = false; } }
      if (navigator.share) { navigator.share({ title: Q.title, text: text, url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(text + ' ' + url).then(function () { done('Link copied'); }, function () { done(url); });
      else done(url);
    }

    // Result-screen clicks (16 Oct 2026): which link or button, logged as an anonymous cohort row. No ref = a shared result link.
    stage.addEventListener('click', function (e) {
      var c = e.target.closest('[data-click]');
      if (c && shown) log('click', shown, true, c.getAttribute('data-click'));
    });

    stage.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var act = b.getAttribute('data-act');
      if (act === 'start') { draw(); renderQ(); }
      else if (act === 'back') { if (idx > 0) { idx--; renderQ(); } }
      else if (act === 'pick') {
        picks[idx] = +b.getAttribute('data-i'); picks.length = idx + 1;
        b.classList.add('is-picked');
        setTimeout(function () { if (idx < qs.length - 1) { idx++; renderQ(); } else renderResult(score(), false); }, 180);
      }
      else if (act === 'restart') { if (shown) log('click', shown, true, ref ? 'again' : 'take'); shown = null; try { history.replaceState(null, '', location.pathname); } catch (e) {} if (ref && !finished) log('abandon'); draw(); renderQ(); }
      else if (act === 'share') { log('click', shown, true, 'share'); share(b.getAttribute('data-k')); }
    });
  }

  function boot() { document.querySelectorAll('.tcc-quiz[data-src]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
